import { render, staticRenderFns } from "./PressKitRss.vue?vue&type=template&id=35e8b811"
import script from "./PressKitRss.vue?vue&type=script&lang=js"
export * from "./PressKitRss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports